<template>
  <div class="user-management">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="用户名">
          <el-input v-model="searchForm.username" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="searchForm.nickname" placeholder="请输入昵称" clearable></el-input>
        </el-form-item>
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同状态">
          <el-select v-model="searchForm.hasContract" placeholder="请选择" clearable>
            <el-option label="已签约" :value="1"></el-option>
            <el-option label="未签约" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架代码">
          <el-input v-model="searchForm.shelfCode" placeholder="模糊匹配上架代码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>用户列表</span>
        <div style="float: right; display: flex; gap: 8px;">
          <el-button type="warning" size="small" icon="el-icon-download" @click="handleDownloadTemplate">导入模版下载</el-button>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="handleOpenImport">导入</el-button>
          <el-button style="margin-left: 0;" type="success" size="small" icon="el-icon-download" @click="handleExport" :loading="exportLoading">导出</el-button>
        </div>
      </div>

        <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="username" label="用户名" width="150"></el-table-column>
        <el-table-column prop="nickname" label="昵称" width="120"></el-table-column>
        <el-table-column prop="groupNickname" label="群昵称" min-width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
        <el-table-column prop="mailingShelfCode" label="邮寄上架代码" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.mailingShelfCode" style="color: #FF8C00;">{{ scope.row.mailingShelfCode }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="crowdfundingShelfCode" label="众筹上架代码" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.crowdfundingShelfCode" style="color: #FF8C00;">{{ scope.row.crowdfundingShelfCode }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.gender === 1">男</span>
            <span v-else-if="scope.row.gender === 2">女</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="roleName" label="角色" width="130">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.roleName" type="warning" size="small">{{ scope.row.roleName }}</el-tag>
            <span v-else style="color: #c0c4cc;">未分配</span>
          </template>
        </el-table-column>
        <el-table-column prop="hasContract" label="合同状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.hasContract === 1" type="success" size="small">已签约</el-tag>
            <el-tag v-else type="info" size="small">未签约</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="contractNo" label="合同编号" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.contractNo" style="color: #FF8C00;">{{ scope.row.contractNo }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractSignedAt" label="签约时间" width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.contractSignedAt) }}</template>
        </el-table-column>
        <el-table-column prop="contractExpireAt" label="到期时间" width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.contractExpireAt) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="340">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleBindRole(scope.row)">绑定角色</el-button>
            <el-button type="text" size="small" @click="handleIssueCoupon(scope.row)" style="color: #E6A23C;">发放优惠券</el-button>
            <el-button type="text" size="small" @click="handleViewContract(scope.row)" v-if="scope.row.hasContract === 1">查看合同</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" :disabled="form.id ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!form.id">
          <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-else>
          <el-input v-model="form.password" type="password" placeholder="留空表示不修改"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>
        <el-form-item label="群昵称" prop="groupNickname">
          <el-input v-model="form.groupNickname" placeholder="请输入群昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" v-if="!form.id">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮寄上架">
          <div class="shelf-code-slots">
            <el-input v-model="form.mailingShelfCodes[0]" maxlength="8" placeholder="代码1" clearable></el-input>
            <el-input v-model="form.mailingShelfCodes[1]" maxlength="8" placeholder="代码2" clearable></el-input>
            <el-input v-model="form.mailingShelfCodes[2]" maxlength="8" placeholder="代码3" clearable></el-input>
          </div>
        </el-form-item>
        <el-form-item label="众筹上架">
          <div class="shelf-code-slots">
            <el-input v-model="form.crowdfundingShelfCodes[0]" maxlength="8" placeholder="代码1" clearable></el-input>
            <el-input v-model="form.crowdfundingShelfCodes[1]" maxlength="8" placeholder="代码2" clearable></el-input>
            <el-input v-model="form.crowdfundingShelfCodes[2]" maxlength="8" placeholder="代码3" clearable></el-input>
          </div>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="0">未知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 合同信息（可编辑） -->
        <el-divider content-position="left">合同信息</el-divider>
        <el-form-item label="签约状态">
          <el-radio-group v-model="form.hasContract" size="small">
            <el-radio :label="1">已签约</el-radio>
            <el-radio :label="0">未签约</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="合同编号" v-if="form.contractNo">
          <span style="color: #FF8C00; font-weight: 600;">{{ form.contractNo }}</span>
        </el-form-item>
        <el-form-item label="签约时间" v-if="form.contractSignedAt">
          {{ formatDate(form.contractSignedAt) }}
        </el-form-item>
        <el-form-item label="到期时间" v-if="form.contractExpireAt">
          {{ formatDate(form.contractExpireAt) }}
        </el-form-item>
        <el-form-item label="合同文件" v-if="form.contractUrl">
          <el-button type="text" size="small" @click="handleDownloadContract">下载合同</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定角色对话框 -->
    <el-dialog title="绑定角色" :visible.sync="roleDialogVisible" width="420px" @close="roleDialogVisible = false">
      <el-form label-width="80px">
        <el-form-item label="用户名">
          <span>{{ roleForm.username }}</span>
        </el-form-item>
        <el-form-item label="当前角色">
          <span v-if="roleForm.currentRoleName" style="color: #FF8C00;">{{ roleForm.currentRoleName }}</span>
          <span v-else style="color: #c0c4cc;">未分配角色</span>
        </el-form-item>
        <el-form-item label="选择角色">
          <el-select v-model="roleForm.roleId" placeholder="请选择角色" clearable style="width: 100%;">
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="roleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRoleSubmit" :loading="roleSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 合同详情对话框 -->
    <el-dialog title="合同详情" :visible.sync="contractDialogVisible" width="500px" @close="contractDialogVisible = false">
      <el-descriptions :column="2" border v-if="contractInfo">
        <el-descriptions-item label="合同编号" :span="2">
          <span style="color: #FF8C00; font-weight: 600;">{{ contractInfo.contractNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="签约状态">
          <el-tag :type="contractInfo.hasContract === 1 ? 'success' : 'info'" size="small">
            {{ contractInfo.hasContract === 1 ? '已签约' : '未签约' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="签约时间">
          {{ formatDate(contractInfo.contractSignedAt) || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="合同文件" :span="2" v-if="contractInfo.contractUrl">
          <el-button type="text" size="small" @click="handleDownloadContract">下载合同</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="合同文件" :span="2" v-else>
          <span style="color: #c0c4cc;">-</span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="contractDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 发放优惠券对话框 -->
    <el-dialog title="发放优惠券" :visible.sync="couponIssueDialogVisible" width="520px" @close="handleCouponIssueDialogClose">
      <el-form :model="couponIssueForm" :rules="couponIssueRules" ref="couponIssueForm" label-width="100px">
        <el-form-item label="用户">
          <span>{{ couponIssueForm.userDisplay }}</span>
        </el-form-item>
        <el-form-item label="优惠券" prop="couponId">
          <el-select v-model="couponIssueForm.couponId" placeholder="请选择优惠券" style="width: 100%;" filterable>
            <el-option
              v-for="c in couponOptions"
              :key="c.id"
              :label="formatCouponLabel(c)"
              :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="couponIssueDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCouponIssueSubmit" :loading="couponIssueLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog title="导入用户" :visible.sync="importDialogVisible" width="500px" @close="handleImportDialogClose">
      <div style="margin-bottom: 16px; color: #909399; font-size: 14px;">
        请先下载模版，填写信息后上传导入。支持 .xlsx 和 .xls 格式。
      </div>
      <el-upload
        ref="upload"
        class="import-uploader"
        drag
        action=""
        :auto-upload="false"
        :limit="1"
        :file-list="importFileList"
        :on-change="handleImportFileChange"
        accept=".xlsx,.xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 .xlsx / .xls 文件</div>
      </el-upload>
      <div slot="footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleImportSubmit" :loading="importLoading">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, addUser, updateUser, deleteUser, updateUserStatus, bindUserRole, getRoleOptions, exportUserList, updateUserContract, downloadUserTemplate, importUser, getCouponList, addCouponIssue } from '@/api'

export default {
  name: 'UserManagement',
  data() {
    return {
      searchForm: {
        username: '',
        nickname: '',
        groupNickname: '',
        phone: '',
        status: null,
        hasContract: null,
        shelfCode: ''
      },
      tableData: [],
      tableLoading: false,
      exportLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      // 角色下拉数据
      roleOptions: [],

      // 新增/编辑弹窗
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        username: '',
        password: '',
        nickname: '',
        groupNickname: '',
        phone: '',
        gender: 0,
        status: 1,
        mailingShelfCodes: ['', '', ''],
        crowdfundingShelfCodes: ['', '', ''],
        hasContract: 0,
        contractNo: '',
        contractUrl: '',
        contractSignedAt: '',
        contractExpireAt: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ]
      },

      // 绑定角色弹窗
      roleDialogVisible: false,
      roleSubmitLoading: false,
      roleForm: {
        userId: null,
        username: '',
        currentRoleName: '',
        roleId: null
      },

      // 合同详情弹窗
      contractDialogVisible: false,
      contractInfo: null,

      // 导入弹窗
      importDialogVisible: false,
      importFile: null,
      importFileList: [],
      importLoading: false,

      // 发放优惠券
      couponIssueDialogVisible: false,
      couponIssueLoading: false,
      couponOptions: [],
      couponIssueForm: {
        userId: null,
        userDisplay: '',
        couponId: null
      },
      couponIssueRules: {
        couponId: [{ required: true, message: '请选择优惠券', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadRoleOptions()
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getUserList(params)
        const list = res.data.list || []
        // 注入角色名称
        this.tableData = list.map(u => ({
          ...u,
          roleName: this.getRoleName(u.roleId)
        }))
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },

    async loadRoleOptions() {
      try {
        const res = await getRoleOptions()
        this.roleOptions = res.data || []
      } catch (e) {
        console.error(e)
      }
    },

    getRoleName(roleId) {
      if (!roleId) return null
      const role = this.roleOptions.find(r => r.id === roleId)
      return role ? role.name : null
    },

    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleReset() {
      this.searchForm = { username: '', nickname: '', groupNickname: '', phone: '', status: null, hasContract: null, shelfCode: '' }
      this.handleSearch()
    },

    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增用户'
      this.form = { id: null, username: '', password: '', nickname: '', groupNickname: '', phone: '', gender: 0, status: 1, mailingShelfCodes: ['', '', ''], crowdfundingShelfCodes: ['', '', ''], hasContract: 0, contractNo: '', contractUrl: '', contractSignedAt: '', contractExpireAt: '' }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑用户'
      const parseShelfCodes = (val) => {
        if (!val) return ['', '', '']
        const parts = val.split(',').concat(['', '', ''])
        return [parts[0] || '', parts[1] || '', parts[2] || '']
      }
      this.form = {
        id: row.id,
        username: row.username,
        password: '',
        nickname: row.nickname || '',
        groupNickname: row.groupNickname || '',
        phone: row.phone || '',
        gender: row.gender || 0,
        status: row.status,
        hasContract: row.hasContract,
        contractNo: row.contractNo,
        contractUrl: row.contractUrl,
        contractSignedAt: row.contractSignedAt,
        contractExpireAt: row.contractExpireAt,
        mailingShelfCodes: parseShelfCodes(row.mailingShelfCode),
        crowdfundingShelfCodes: parseShelfCodes(row.crowdfundingShelfCode)
      }
      this.dialogVisible = true
    },

    handleDialogClose() {
      this.$refs.form.resetFields()
    },

    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        try {
          const mailingCodes = this.form.mailingShelfCodes.filter(c => c.trim())
          const crowdfundingCodes = this.form.crowdfundingShelfCodes.filter(c => c.trim())
          const allCodes = [...mailingCodes, ...crowdfundingCodes]
          const hasDuplicate = allCodes.length !== new Set(allCodes).size
          if (hasDuplicate) {
            this.$message.error('邮寄上架代码与众筹上架代码不能重复')
            return
          }
          const data = { ...this.form }
          data.mailingShelfCode = mailingCodes.join(',')
          data.crowdfundingShelfCode = crowdfundingCodes.join(',')
          delete data.mailingShelfCodes
          delete data.crowdfundingShelfCodes
          if (this.form.id) {
            await updateUser(data)
            await updateUserContract(this.form.id, {
              hasContract: data.hasContract
            })
            this.$message.success('更新成功')
          } else {
            await addUser(data)
            this.$message.success('添加成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        }
      })
    },

    // 绑定角色
    handleBindRole(row) {
      this.roleForm = {
        userId: row.id,
        username: row.username,
        currentRoleName: this.getRoleName(row.roleId) || '',
        roleId: row.roleId || null
      }
      this.roleDialogVisible = true
    },

    async handleRoleSubmit() {
      this.roleSubmitLoading = true
      try {
        await bindUserRole(this.roleForm.userId, this.roleForm.roleId)
        this.$message.success('角色绑定成功')
        this.roleDialogVisible = false
        this.loadData()
      } catch (e) {
        console.error(e)
      } finally {
        this.roleSubmitLoading = false
      }
    },

    async loadCouponOptions() {
      try {
        const res = await getCouponList({ pageNum: 1, pageSize: 200 })
        const records = res.data?.records || res.data || []
        this.couponOptions = records.filter(c => c.status === 1 && (c.remainStock || 0) > 0)
      } catch (e) {
        console.error(e)
        this.couponOptions = []
      }
    },

    formatCouponLabel(c) {
      if (c.type === 1) {
        return `${c.name}（满${c.threshold || 0}减${c.discount}，剩余${c.remainStock}张）`
      }
      return `${c.name}（${(c.discount * 10).toFixed(1)}折，剩余${c.remainStock}张）`
    },

    async handleIssueCoupon(row) {
      await this.loadCouponOptions()
      if (this.couponOptions.length === 0) {
        this.$message.warning('暂无可发放的优惠券（需启用且有剩余库存）')
        return
      }
      const displayName = row.groupNickname || row.nickname || row.username || `用户${row.id}`
      this.couponIssueForm = {
        userId: row.id,
        userDisplay: `${displayName}${row.phone ? `（${row.phone}）` : ''}`,
        couponId: null
      }
      this.couponIssueDialogVisible = true
    },

    handleCouponIssueDialogClose() {
      this.$refs.couponIssueForm && this.$refs.couponIssueForm.resetFields()
      this.couponIssueForm = {
        userId: null,
        userDisplay: '',
        couponId: null
      }
    },

    handleCouponIssueSubmit() {
      this.$refs.couponIssueForm.validate(async (valid) => {
        if (!valid) return
        this.couponIssueLoading = true
        try {
          await addCouponIssue({
            couponId: this.couponIssueForm.couponId,
            userId: this.couponIssueForm.userId,
            status: 0
          })
          this.$message.success('发放成功')
          this.couponIssueDialogVisible = false
        } catch (e) {
          // 错误已在拦截器处理
        } finally {
          this.couponIssueLoading = false
        }
      })
    },

    // 切换状态
    async handleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const text = newStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${text}该用户吗？`, '提示', { type: 'warning' })
        await updateUserStatus(row.id, newStatus)
        this.$message.success(`${text}成功`)
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },

    // 查看合同
    handleViewContract(row) {
      this.contractInfo = { ...row }
      this.contractDialogVisible = true
    },

    handleDownloadContract() {
      const url = this.contractInfo ? this.contractInfo.contractUrl : this.form.contractUrl
      if (url) {
        const a = document.createElement('a')
        a.href = url
        a.download = '委托寄售合同.pdf'
        a.click()
      }
    },

    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteUser(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    },

    async handleExport() {
      this.exportLoading = true
      try {
        const params = { ...this.searchForm }
        const res = await exportUserList(params)
        const blob = new Blob([res.__blob.data], { type: 'text/csv;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '用户列表.csv'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        console.error(e)
      } finally {
        this.exportLoading = false
      }
    },

    async handleDownloadTemplate() {
      try {
        const res = await downloadUserTemplate()
        const blob = new Blob([res.__blob.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '用户迁移模版.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('模版下载成功')
      } catch (e) {
        console.error(e)
        this.$message.error('模版下载失败')
      }
    },

    handleOpenImport() {
      this.importFile = null
      this.importFileList = []
      this.importDialogVisible = true
    },

    handleImportFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.importFile = fileList[0].raw
        this.importFileList = fileList.slice(-1)
      } else {
        this.importFile = null
        this.importFileList = []
      }
    },

    handleImportDialogClose() {
      this.importFile = null
      this.importFileList = []
    },

    async handleImportSubmit() {
      if (!this.importFile) {
        this.$message.warning('请先选择要导入的Excel文件')
        return
      }
      this.importLoading = true
      try {
        const res = await importUser(this.importFile)
        this.$message.success(`导入成功，共导入 ${res.data.count} 条用户记录`)
        this.importDialogVisible = false
        this.loadData()
      } catch (e) {
        console.error(e)
      } finally {
        this.importLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.user-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}

.shelf-code-slots {
  display: flex;
  gap: 8px;
}
</style>
